import * as React from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import SimpleCard from './SimpleCard'
import DashboardsPostagens from '../../../services/http/dashboards/DashboardsPostagens'
import { object } from 'prop-types'
import { mapFilterKeys } from '../../../utils/filterUtils'
export default function CardMaiorNumeroPaginas({ filters }) {
  const [postagem, setPostagem] = React.useState({
    leitor_nome: '',
    sum_numero_pagina: 0
  })

  const [loading, setLoading] = React.useState(true)

  async function getResumos(filters) {
    setLoading(true)

    const filterKeyMap = {
      biblioteca_id: 'leitor_biblioteca_id',
      funcao_id: 'leitor_funcao',
      departamento_id: 'leitor_departamento'
    }

    const filtroAdaptado = mapFilterKeys(filters, filterKeyMap)

    try {
      const { data } = await DashboardsPostagens().show({
        group_by: 'leitor_id,leitor_nome,status_postagem_id',
        per_page: 1,
        status_postagem_id: [1, 2],
        count: 'numero_pagina',
        'order_by[sum_numero_pagina]': 'desc',
        ...filtroAdaptado
      })
      setPostagem(
        data.data[0] || {
          leitor_nome: '',
          sum_numero_pagina: 0
        }
      )
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if (Object.keys(filters).length > 0) getResumos(filters)
  }, [filters])
  return (
    <Box>
      <Card variant="outlined">
        <SimpleCard
          title="Maior número de páginas lidas"
          subtitle={`Leitor: ${postagem.leitor_nome}`}
          footer={`Quantidade de páginas: ${postagem.sum_numero_pagina?.toLocaleString(
            'pt-br'
          )}`}
          loading={loading}
        />
      </Card>
    </Box>
  )
}

CardMaiorNumeroPaginas.propTypes = {
  filters: object
}
